<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,6C0.9,6,0,6.9,0,8C0,9.1,0.9,10,2,10C3.1,10,4,9.1,4,8C4,6.9,3.1,6,2,6C2,6,2,6,2,6ZM14,4C15.1,4,16,3.1,16,2C16,0.9,15.1,0,14,0C12.9,0,12,0.9,12,2C12,3.1,12.9,4,14,4C14,4,14,4,14,4ZM2,12C0.9,12,0,12.9,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,12.9,3.1,12,2,12C2,12,2,12,2,12ZM2,0C0.9,0,0,0.9,0,2C0,3.1,0.9,4,2,4C3.1,4,4,3.1,4,2C4,0.9,3.1,0,2,0C2,0,2,0,2,0ZM8,9C6.9,9,6,9.9,6,11C6,12.1,6.9,13,8,13C9.1,13,10,12.1,10,11C10,9.9,9.1,9,8,9C8,9,8,9,8,9ZM14,6C12.9,6,12,6.9,12,8C12,9.1,12.9,10,14,10C15.1,10,16,9.1,16,8C16,6.9,15.1,6,14,6C14,6,14,6,14,6ZM8,3C6.9,3,6,3.9,6,5C6,6.1,6.9,7,8,7C9.1,7,10,6.1,10,5C10,3.9,9.1,3,8,3C8,3,8,3,8,3ZM14,12C12.9,12,12,12.9,12,14C12,15.1,12.9,16,14,16C15.1,16,16,15.1,16,14C16,12.9,15.1,12,14,12C14,12,14,12,14,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutSkewGrid',
} as DefineComponent
</script>
